import { render, staticRenderFns } from "./PersonModel.vue?vue&type=template&id=bc13abbc&scoped=true"
import script from "./PersonModel.vue?vue&type=script&lang=js"
export * from "./PersonModel.vue?vue&type=script&lang=js"
import style0 from "./PersonModel.vue?vue&type=style&index=0&id=bc13abbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc13abbc",
  null
  
)

export default component.exports